import { SERVICES } from "@/data/content";
import { Reveal } from "./Reveal";
import { GALLERY } from "@/data/content";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-ink overflow-hidden grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: `url(${GALLERY[2].url})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/95 to-ink" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="max-w-2xl">
          <p className="text-sm uppercase tracking-[0.3em] text-gold font-semibold mb-4">
            What We Do
          </p>
          <h2 className="font-display text-cream text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Full-Service Care for Extraordinary Outdoor Spaces
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.08}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group glass-dark p-8 lg:p-10 h-full transition-all duration-500 hover:-translate-y-2 hover:border-gold/40 hover:shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
                >
                  <div className="w-14 h-14 flex items-center justify-center border border-gold/40 mb-6 group-hover:bg-gold group-hover:border-gold transition-colors duration-500">
                    <Icon className="text-gold group-hover:text-ink transition-colors duration-500" size={26} />
                  </div>
                  <h3 className="font-display text-xl text-cream mb-3 tracking-wide">
                    {s.title}
                  </h3>
                  <p className="text-cream/60 leading-relaxed text-[15px]">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
